/**
 * Lightweight context for navigating between embed views from deep components
 * (e.g. AssetWidget inside Thread can navigate to the documents view).
 */

import { createContext, useContext } from 'react';

export interface NavigationContextValue {
  /** Navigate to the documents view, optionally pre-selecting a file by its GCS path. */
  navigateToDocument: (objectPath: string) => void;
}

export const NavigationContext = createContext<NavigationContextValue | null>(null);

/** Returns the embed navigation context, or null when not inside the embed. */
export function useOptionalNavigation(): NavigationContextValue | null {
  return useContext(NavigationContext);
}
